<template>
	<div>
		<NavigationHeader :title="title"></NavigationHeader>
		<slot></slot>
	</div>
</template>

<script>
import NavigationHeader from '@/components/navigation/NavigationHeader';

export default {
	props: {
		title: {
			type: String,
			required: true,
			default: '',
		},
	},
	components: {
		NavigationHeader,
	},
};
</script>

<style lang="sass" scoped></style>
